export default __webpack_public_path__ + "static/media/end.faa7dc6a.svg";